export const STATUS_NEW = 'new';
export const STATUS_ACTIVE = 'active';
export const STATUS_COMPLETED = 'completed';
export const STATUS_CANCELLED = 'cancelled';
